import React from "react";
import { Link } from "react-router-dom";
import { RiReactjsFill } from "react-icons/ri";
import { FaCss3Alt } from "react-icons/fa";
import { TbBrandJavascript } from "react-icons/tb";
import { SiTailwindcss } from "react-icons/si";
import { SiPython } from "react-icons/si";
import { FaNodeJs } from "react-icons/fa";
import { BsFiletypeSql } from "react-icons/bs";
import { SiMongodb } from "react-icons/si";
import { IoLogoFirebase } from "react-icons/io5";
import { FaFigma } from "react-icons/fa";
import { BsFiletypeHtml } from "react-icons/bs";
import { SiPostman } from "react-icons/si";

export const Skills = () => {
  return (
    <div className="bg-gray-200 h-[calc(87dvh)] flex flex-col  items-center ">
      <div className="text-2xl font-extrabold text-gray-900 mt-10   ">
        <p>Skills</p>
      </div>
      <div className="grid grid-cols-3 gap-4 mt-24">
        <Link
          to="https://react.dev/"
          target="_blank"
          className=" animate-fade-right animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-sky-500 hover:text-sky-900 "
        >
          <RiReactjsFill size={50} /> <p>ReactJS</p>
        </Link>

        <Link
          to="https://developer.mozilla.org/en-US/docs/Web/CSS"
          target="_blank"
          className=" animate-fade animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-orange-500 hover:text-orange-900"
        >
          <FaCss3Alt size={50} /> <p>CSS</p>
        </Link>
        <Link
          to="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
          target="_blank"
          className=" animate-fade-left animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-yellow-500 hover:text-yellow-800"
        >
          <TbBrandJavascript size={50} /> <p>JavaScript</p>
        </Link>
        <Link
          to="https://tailwindcss.com/docs/installation"
          className=" animate-fade-right animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-teal-500 hover:text-teal-900"
        >
          <SiTailwindcss size={50} /> <p>TailwindCSS</p>
        </Link>
        <Link
          to="https://www.python.org/"
          target="_blank"
          className=" animate-fade animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-amber-400 hover:text-amber-900"
        >
          <SiPython size={50} /> <p>Python</p>
        </Link>
        <Link
          to="https://nodejs.org/en"
          target="_blank"
          className="animate-fade-left animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-green-500 hover:text-green-900"
        >
          <FaNodeJs size={50} /> <p>NodeJS</p>
        </Link>
        <Link
          to="https://www.w3schools.com/sql/sql_quickref.asp"
          target="_blank"
          className="animate-fade-right animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-indigo-500 hover:text-indigo-900"
        >
          <BsFiletypeSql size={50} /> <p>SQL</p>
        </Link>
        <Link
          to="https://www.mongodb.com/docs/"
          target="_blank"
          className=" animate-fade animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-emerald-700 hover:text-emerald-950"
        >
          <SiMongodb size={50} /> <p>MongoDB</p>
        </Link>
        <Link
          to="https://firebase.google.com/docs"
          className=" animate-fade-left animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-yellow-400 hover:text-yellow-900"
        >
          <IoLogoFirebase size={50} /> <p>Firebase</p>
        </Link>
        <Link
          to="https://help.figma.com/hc/en-us"
          target="_blank"
          className=" animate-fade-right animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-purple-500 hover:text-purple-900"
        >
          <FaFigma size={50} /> <p>UX Design</p>
        </Link>
        <Link
          to="https://developer.mozilla.org/en-US/docs/Web/HTML"
          target="_blank"
          className=" animate-fade animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-gray-500  hover:text-gray-900"
        >
          <BsFiletypeHtml size={50} /> <p>HTML</p>
        </Link>
        <Link
          to="https://developer.mozilla.org/en-US/docs/Web/API"
          target="_blank"
          className=" animate-fade-left animate-once animate-duration-[6000ms] animate-ease-linear cursor-pointer flex items-center gap-1 p-4 text-xl text-red-500 hover:text-red-900"
        >
          <SiPostman size={50} /> <p>Web API</p>
        </Link>
      </div>
    </div>
  );
};

export default Skills;
